var e;!function(e){e.select="select",e.multiselect="multiselect",e.text="text",e.textarea="textarea",e.date="date",e.daterange="daterange",e.number="number",e.autocomplete="autocomplete"}(e||(e={}));export{e as INPUT_TYPE};
//# sourceMappingURL=form.js.map
